// @flow

import { isFunction } from "lodash";
import type { Immutable } from "seamless-immutable";
import produce from "@cld/immer";

export const mergeUniquelyToImmutableArray = (newList: Object[], existList: Immutable, findIndex: Function) => {
	newList.forEach((item) => {
		const indx = findIndex ? findIndex(existList, item) : existList.indexOf(item);

		existList = (~indx
			? existList.set(indx, item) // found in existing, set inside
			: existList.concat(item)); // add new item
	});

	return existList;
};

const throwNonFunctionReducer = (types: Object, action: Object) => {
	throw new Error(`Reducer must provide a function only per type,
                found ${typeof types[action.type]} for type: ${action.type}`);
};

const createReducer = (initialState: Object, types: Object) => (state: Object, action: Object) => (types[action.type]
	? (isFunction(types[action.type])
		? types[action.type]((state || initialState), action)
		: throwNonFunctionReducer(types, action))
	: (state || initialState));


export const createImmerReducer = (initialState: Object, types: Object) => produce(createReducer(initialState, types));

export default createReducer;
